/* =========================================================
   CUSTOM EMBROIDERY - DAWN THEME
   STEP 1 FRONTEND
   ========================================================= */

(function () {
  'use strict';

  const MONEY_FORMAT = window.Shopify?.money_format || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, MONEY_FORMAT);
    }

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-IN',
      {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }
    ).format(cents / 100);
  }

  function initEmbroidery(root) {

    if (!root || root.dataset.ceInitialized === 'true') {
      return;
    }

    root.dataset.ceInitialized = 'true';

    const modal = root.querySelector('[data-ce-modal]');

    if (!modal) {
      return;
    }

    const openButton = root.querySelector('[data-ce-open]');
    const closeButtons = root.querySelectorAll('[data-ce-close]');

    const textToggle = root.querySelector('[data-ce-text-toggle]');
    const logoToggle = root.querySelector('[data-ce-logo-toggle]');

    const textFields = root.querySelector('[data-ce-text-fields]');
    const logoFields = root.querySelector('[data-ce-logo-fields]');

    const nameInput = root.querySelector('[data-ce-name]');
    const designationInput = root.querySelector('[data-ce-designation]');

    const colorSelect = root.querySelector('[data-ce-color]');
    const fontSelect = root.querySelector('[data-ce-font]');

    const logoInput = root.querySelector('[data-ce-logo]');
    const logoPreview = root.querySelector('[data-ce-logo-preview]');

    const filePreview = root.querySelector('[data-ce-file-preview]');
    const fileName = root.querySelector('[data-ce-file-name]');
    const fileSize = root.querySelector('[data-ce-file-size]');

    const removeLogoButton = root.querySelector('[data-ce-remove-logo]');

    const errorBox = root.querySelector('[data-ce-error]');

    const summaryEmpty = root.querySelector('[data-ce-empty]');
    const summaryContent = root.querySelector('[data-ce-summary]');

    const summaryText = root.querySelector('[data-ce-summary-text]');
    const summaryTextDetails = root.querySelector('[data-ce-summary-text-details]');

    const summaryLogo = root.querySelector('[data-ce-summary-logo]');
    const summaryLogoDetails = root.querySelector('[data-ce-summary-logo-details]');

    const totalElement = root.querySelector('[data-ce-total]');
    const saveTotalElement = root.querySelector('[data-ce-save-total]');

    const saveButton = root.querySelector('[data-ce-save]');

    const textPrice = parseInt(root.dataset.textPrice || '10000', 10);
    const logoPrice = parseInt(root.dataset.logoPrice || '10000', 10);

    let selectedLogoFile = null;

    let embroideryState = {
      textEnabled: false,
      logoEnabled: false,

      name: '',
      designation: '',

      color: 'White',
      font: 'Block',

      logoFile: null,

      textPrice: textPrice,
      logoPrice: logoPrice,

      total: 0
    };


    /* =====================================================
       HELPERS
       ===================================================== */

    function showError(message) {
      if (!errorBox) return;

      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function clearError() {
      if (!errorBox) return;

      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function setHidden(element, hidden) {
      if (!element) return;

      element.hidden = hidden;
    }

    function calculateTotal() {

      let total = 0;

      if (embroideryState.textEnabled) {
        total += textPrice;
      }

      if (embroideryState.logoEnabled) {
        total += logoPrice;
      }

      embroideryState.total = total;

      if (totalElement) {
        totalElement.textContent = formatMoney(total);
      }

      if (saveTotalElement) {
        saveTotalElement.textContent = formatMoney(total);
      }
    }


    /* =====================================================
       SUMMARY
       ===================================================== */

    function updateSummary() {

      const hasAny =
        embroideryState.textEnabled ||
        embroideryState.logoEnabled;

      setHidden(summaryEmpty, hasAny);
      setHidden(summaryContent, !hasAny);

      setHidden(
        summaryText,
        !embroideryState.textEnabled
      );

      setHidden(
        summaryLogo,
        !embroideryState.logoEnabled
      );

      if (embroideryState.textEnabled && summaryTextDetails) {

        const parts = [];

        if (embroideryState.name) {
          parts.push(
            'Name: ' + embroideryState.name
          );
        }

        if (embroideryState.designation) {
          parts.push(
            'Designation: ' + embroideryState.designation
          );
        }

        parts.push(
          'Color: ' + embroideryState.color
        );

        parts.push(
          'Font: ' + embroideryState.font
        );

        summaryTextDetails.textContent =
          parts.join(' • ');
      }

      if (embroideryState.logoEnabled && summaryLogoDetails) {

        if (embroideryState.logoFile) {

          summaryLogoDetails.textContent =
            embroideryState.logoFile.name;

        } else {

          summaryLogoDetails.textContent =
            'Logo not uploaded yet';

        }
      }

      calculateTotal();
    }


    /* =====================================================
       OPEN MODAL
       ===================================================== */

    function openModal() {

      clearError();

      modal.hidden = false;

      document.body.classList.add('ce-modal-open');

      document.dispatchEvent(
        new CustomEvent('custom-embroidery:open')
      );

      requestAnimationFrame(function () {

        if (textToggle) {
          textToggle.focus();
        }

      });
    }


    /* =====================================================
       CLOSE MODAL
       ===================================================== */

    function closeModal() {

      modal.hidden = true;

      document.body.classList.remove('ce-modal-open');

      document.dispatchEvent(
        new CustomEvent('custom-embroidery:close')
      );
    }


    /* =====================================================
       TEXT TOGGLE
       ===================================================== */

    if (textToggle) {

      textToggle.addEventListener('change', function () {

        embroideryState.textEnabled =
          textToggle.checked;

        setHidden(
          textFields,
          !textToggle.checked
        );

        clearError();

        updateSummary();
      });
    }


    /* =====================================================
       LOGO TOGGLE
       ===================================================== */

    if (logoToggle) {

      logoToggle.addEventListener('change', function () {

        embroideryState.logoEnabled =
          logoToggle.checked;

        setHidden(
          logoFields,
          !logoToggle.checked
        );

        clearError();

        updateSummary();
      });
    }


    /* =====================================================
       TEXT INPUTS
       ===================================================== */

    if (nameInput) {

      nameInput.addEventListener('input', function () {

        embroideryState.name =
          nameInput.value.trim();

        updateSummary();
      });
    }


    if (designationInput) {

      designationInput.addEventListener('input', function () {

        embroideryState.designation =
          designationInput.value.trim();

        updateSummary();
      });
    }


    if (colorSelect) {

      colorSelect.addEventListener('change', function () {

        embroideryState.color =
          colorSelect.value;

        updateSummary();
      });
    }


    if (fontSelect) {

      fontSelect.addEventListener('change', function () {

        embroideryState.font =
          fontSelect.value;

        updateSummary();
      });
    }


    /* =====================================================
       LOGO UPLOAD
       ===================================================== */

    if (logoInput) {

      logoInput.addEventListener('change', function (event) {

        clearError();

        const file =
          event.target.files &&
          event.target.files[0];

        if (!file) {
          return;
        }

        const maxSize = 5 * 1024 * 1024;

        const allowedTypes = [
          'image/png',
          'image/jpeg',
          'image/webp'
        ];

        if (!allowedTypes.includes(file.type)) {

          showError(
            'Please upload a PNG, JPG or WEBP logo.'
          );

          logoInput.value = '';

          return;
        }

        if (file.size > maxSize) {

          showError(
            'Logo file size must be 5 MB or less.'
          );

          logoInput.value = '';

          return;
        }

        selectedLogoFile = file;

        embroideryState.logoFile = file;

        if (fileName) {
          fileName.textContent = file.name;
        }

        if (fileSize) {

          fileSize.textContent =
            formatFileSize(file.size);
        }

        const reader =
          new FileReader();

        reader.onload = function (readerEvent) {

          if (logoPreview) {

            logoPreview.src =
              readerEvent.target.result;
          }

          setHidden(
            filePreview,
            false
          );
        };

        reader.readAsDataURL(file);

        updateSummary();
      });
    }


    /* =====================================================
       REMOVE LOGO
       ===================================================== */

    if (removeLogoButton) {

      removeLogoButton.addEventListener(
        'click',
        function () {

          selectedLogoFile = null;

          embroideryState.logoFile = null;

          if (logoInput) {
            logoInput.value = '';
          }

          if (logoPreview) {
            logoPreview.removeAttribute('src');
          }

          setHidden(
            filePreview,
            true
          );

          clearError();

          updateSummary();
        }
      );
    }


    /* =====================================================
       FILE SIZE
       ===================================================== */

    function formatFileSize(bytes) {

      if (bytes === 0) {
        return '0 Bytes';
      }

      const units = [
        'Bytes',
        'KB',
        'MB'
      ];

      const i = Math.floor(
        Math.log(bytes) /
        Math.log(1024)
      );

      return (
        parseFloat(
          (bytes / Math.pow(1024, i))
            .toFixed(2)
        )
        + ' '
        + units[i]
      );
    }


    /* =====================================================
       VALIDATION
       ===================================================== */

    function validate() {

      clearError();

      if (
        !embroideryState.textEnabled &&
        !embroideryState.logoEnabled
      ) {

        showError(
          'Please select Add Text or Add Logo.'
        );

        return false;
      }


      if (embroideryState.textEnabled) {

        if (!embroideryState.name) {

          showError(
            'Please enter the embroidery name.'
          );

          if (nameInput) {
            nameInput.focus();
          }

          return false;
        }

        if (!embroideryState.designation) {

          showError(
            'Please enter the designation.'
          );

          if (designationInput) {
            designationInput.focus();
          }

          return false;
        }
      }


      if (
        embroideryState.logoEnabled &&
        !embroideryState.logoFile
      ) {

        showError(
          'Please upload your logo.'
        );

        return false;
      }


      return true;
    }


    /* =====================================================
       CREATE CART PROPERTIES
       ===================================================== */

    function createCartProperties() {

      const properties = {};

      properties['_Embroidery Selected'] = 'Yes';

      properties['Embroidery Text'] =
        embroideryState.textEnabled
          ? 'Yes'
          : 'No';

      properties['Embroidery Logo'] =
        embroideryState.logoEnabled
          ? 'Yes'
          : 'No';


      if (embroideryState.textEnabled) {

        properties['Embroidery Name'] =
          embroideryState.name;

        properties['Embroidery Designation'] =
          embroideryState.designation;

        properties['Embroidery Text Color'] =
          embroideryState.color;

        properties['Embroidery Font'] =
          embroideryState.font;

        properties['_Embroidery Text Price'] =
          formatMoney(textPrice);
      }


      if (embroideryState.logoEnabled) {

        properties['Embroidery Logo File'] =
          embroideryState.logoFile
            ? embroideryState.logoFile.name
            : '';

        properties['_Embroidery Logo Price'] =
          formatMoney(logoPrice);
      }


      properties['_Embroidery Total'] =
        formatMoney(
          embroideryState.total
        );


      /*
       * IMPORTANT:
       *
       * Actual Shopify logo upload will be
       * implemented in Step 2.
       *
       * At that stage:
       *
       * properties['_Embroidery Logo URL']
       *
       * will contain the secure uploaded
       * Shopify file URL.
       */


      return properties;
    }


    /* =====================================================
       SAVE / CONTINUE
       ===================================================== */

    if (saveButton) {

      saveButton.addEventListener(
        'click',
        async function () {

          if (!validate()) {
            return;
          }

          const properties =
            createCartProperties();

          /*
           * Store temporarily so that the
           * product form integration can
           * use it.
           */

          window.customEmbroideryData = {
            ...embroideryState,
            properties: properties
          };


          /*
           * Dispatch event.
           *
           * Dawn product form integration
           * can listen to this.
           */

          document.dispatchEvent(
            new CustomEvent(
              'custom-embroidery:saved',
              {
                detail: {
                  state: embroideryState,
                  properties: properties
                }
              }
            )
          );


          /*
           * Update trigger button.
           */

          if (openButton) {

            openButton.classList.add(
              'ce__trigger--selected'
            );

            const arrow =
              openButton.querySelector(
                '.ce__trigger-arrow'
              );

            if (arrow) {
              arrow.textContent = '✓';
            }
          }


          closeModal();

          /*
           * Small confirmation event.
           */

          document.dispatchEvent(
            new CustomEvent(
              'custom-embroidery:updated',
              {
                detail: {
                  state: embroideryState,
                  properties: properties
                }
              }
            )
          );
        }
      );
    }


    /* =====================================================
       OPEN / CLOSE
       ===================================================== */

    if (openButton) {

      openButton.addEventListener(
        'click',
        openModal
      );
    }


    closeButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        closeModal
      );

    });


    /* =====================================================
       ESC KEY
       ===================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          !modal.hidden
        ) {
          closeModal();
        }

      }
    );


    /* =====================================================
       INITIAL STATE
       ===================================================== */

    updateSummary();


    /*
     * Public API for this instance.
     */

    root.customEmbroidery = {

      getState: function () {
        return {
          ...embroideryState
        };
      },

      getProperties: function () {
        return createCartProperties();
      },

      open: openModal,

      close: closeModal,

      reset: function () {

        embroideryState = {
          textEnabled: false,
          logoEnabled: false,

          name: '',
          designation: '',

          color: 'White',
          font: 'Block',

          logoFile: null,

          textPrice: textPrice,
          logoPrice: logoPrice,

          total: 0
        };

        selectedLogoFile = null;

        if (textToggle) {
          textToggle.checked = false;
        }

        if (logoToggle) {
          logoToggle.checked = false;
        }

        if (nameInput) {
          nameInput.value = '';
        }

        if (designationInput) {
          designationInput.value = '';
        }

        if (colorSelect) {
          colorSelect.value = 'White';
        }

        if (fontSelect) {
          fontSelect.value = 'Block';
        }

        if (logoInput) {
          logoInput.value = '';
        }

        setHidden(textFields, true);
        setHidden(logoFields, true);
        setHidden(filePreview, true);

        updateSummary();
      }
    };
  }


  /* =======================================================
     INITIALIZE ALL EMBROIDERY COMPONENTS
     ======================================================= */

  function initAll() {

    document
      .querySelectorAll('.ce')
      .forEach(initEmbroidery);
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();
  }


  /*
   * Dawn Shopify Theme Editor support
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      event.target
        .querySelectorAll('.ce')
        .forEach(initEmbroidery);
    }
  );

})();